import { useState, useEffect } from 'react';

export const useSelectRow = (data: any, key = 'id', option?: {
  isSingle?: boolean,
  init?: any[]
}) => {
  
  const { isSingle, init } = option || {}
  const [ rowSelected, setRowSelected ] = useState<any>([])

  useEffect(() => {
    if (init) {
      if (Array.isArray(init)) {
        setRowSelected(init)
      } else {
        setRowSelected([init])
      }
    }
  }, [init])

  const onSelectRow = (e:any) => {
    const value = e;
    if (Array.isArray(e)) {
      setRowSelected(e)
    }else{
      if (value[key] === 'all') {
        if (e.checked) {
          setRowSelected(data.map((item:any) => item))
        } else {
          setRowSelected([])
        }
      } else {
        if (isSingle) {
          setRowSelected([e])
        } else {
          if (rowSelected.find((e:any) => e[key] === value[key])) {
            setRowSelected([...rowSelected].filter(e => e[key] !== value[key]))
          } else {
            setRowSelected((p:any) => [...p, e])
          }
        }
      }
    }
  }

  return [ rowSelected, onSelectRow ]
}

// Usage
// const [ rowSelected, onSelectRow ] = useSelectRow(dataList)
